import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import {
  formatInteger,
  formatSignedInteger,
  formatSignedPercent,
} from './fnbEodReportUtils'

export default function FnbEodReportVariance({
  variance,
  varianceAvailable,
  varianceCountsRecorded,
  varianceAllMatched,
  inventorySetupRequired,
  onEnterCounts,
}) {
  return (
    <Card body className="card--md">
      <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-3">
        <h2 className="h5 mb-0">Variance Report</h2>
        {varianceAvailable && onEnterCounts ? (
          <ButtonLikeControl onClick={onEnterCounts}>
            Enter closing counts
          </ButtonLikeControl>
        ) : null}
      </div>

      {!varianceAvailable ? (
        <EmptyContainer>
          <p className="mb-2">
            {inventorySetupRequired
              ? 'Set beginning inventory for this stand, then enter closing counts to generate variances.'
              : 'Select a stand and complete inventory setup to enable variance reporting.'}
          </p>
          <p className="mb-0 small text-muted">
            Negative variances can indicate unrecorded comps, shrinkage, count
            errors, POS mistakes, or over-pouring at bars.
          </p>
        </EmptyContainer>
      ) : !varianceCountsRecorded ? (
        <EmptyContainer>
          <p className="mb-2">
            No closing counts recorded yet. Enter physical counts at stand close
            to populate this section.
          </p>
          <p className="mb-0 small text-muted">
            Negative variances can indicate unrecorded complimentary items,
            theft/shrinkage, incorrect inventory counts, POS mistakes, or
            over-pouring at bars.
          </p>
        </EmptyContainer>
      ) : varianceAllMatched ? (
        <EmptyContainer>
          <p className="mb-2">
            All recorded closing counts match expected ending inventory.
          </p>
          <p className="mb-0 small text-muted">
            No variances to review for this stand and date.
          </p>
        </EmptyContainer>
      ) : !variance?.length ? (
        <EmptyContainer>
          <p className="mb-0 small text-muted">
            No variance items for this stand and date.
          </p>
        </EmptyContainer>
      ) : (
        <>
          <div className="table-container border-bottom-0">
            <Table responsive className="mb-3 fnb-eod-table">
              <thead>
                <tr>
                  <th className="text-left uppercase text-body">Item</th>
                  <th className="text-right uppercase text-body">Expected</th>
                  <th className="text-right uppercase text-body">Actual</th>
                  <th className="text-right uppercase text-body">Variance</th>
                  <th className="text-right uppercase text-body">Variance %</th>
                </tr>
              </thead>
              <tbody>
                {variance.map((row) => {
                  const isNegative = Number(row.variance) < 0
                  const isPositive = Number(row.variance) > 0
                  const rowClass = isNegative
                    ? 'fnb-eod-variance-row--negative'
                    : isPositive
                      ? 'fnb-eod-variance-row--positive'
                      : ''

                  return (
                    <tr key={row.itemId || row.itemName} className={rowClass}>
                      <td className="text-left">{row.itemName}</td>
                      <td className="text-right">
                        {formatInteger(row.expectedEnding)}
                      </td>
                      <td className="text-right">
                        {formatInteger(row.actualCount)}
                      </td>
                      <td className="text-right">
                        {formatSignedInteger(row.variance)}
                      </td>
                      <td className="text-right">
                        {formatSignedPercent(row.variancePercent)}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
          <p className="mb-0 small text-muted">
            Negative variances can indicate unrecorded complimentary items,
            theft/shrinkage, incorrect inventory counts, POS mistakes, or
            over-pouring at bars.
          </p>
        </>
      )}
    </Card>
  )
}

function ButtonLikeControl({ onClick, children }) {
  return (
    <button
      type="button"
      className="btn btn-link btn-sm p-0 text-decoration-none"
      onClick={onClick}
    >
      {children}
    </button>
  )
}
